/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { FindOptions } from './common';
import { entityService } from './services';

const pathname = '/entity-material-sub-categories';

export const EntityMaterialSubCategoryApi = {
  filter: async (options: FindOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};
